import { MessageView, type Post } from '@entities/post'
import { CustomTag } from '@shared/ui/custom-tag/custom-tag'
import { Button, Flex } from 'antd'
import { Popup } from 'antd-mobile'

interface PreviewPostMobileProps {
    open: boolean
    post: Post | null
    onClose: () => void
    onEditModalOpen?: (post: Post) => void
}

export const PreviewPostMobileModal = ({ open, onClose, post, onEditModalOpen }: PreviewPostMobileProps) => {
    const handleEditModalOpen = () => {
        if (onEditModalOpen && post) {
            onEditModalOpen(post)
            onClose()
        }
    }
    if (!post) {
        return null
    }

    console.log('post.postType', post.postType)

    return (
        <Popup visible={open} onMaskClick={onClose} onClose={onClose} bodyStyle={{ background: '#F0F3F5' }}>
            <div style={{ padding: '20px' }}>
                {post.postType && post.postType.value && (
                    <div style={{ marginBottom: 20 }}>
                        <CustomTag color={post.postType?.color}>{post.postType.name}</CustomTag>
                    </div>
                )}
                <Flex gap="middle" vertical>
                    {post.messages.map((item) => (
                        <MessageView message={item} key={item.id} />
                    ))}
                </Flex>
                {onEditModalOpen && (
                    <Button
                        type="primary"
                        key="edit"
                        size="large"
                        style={{ width: '100%', marginTop: '16px' }}
                        onClick={handleEditModalOpen}
                        disabled={post.isAdvertising && post.state === 'planned'}
                    >
                        Редактировать
                    </Button>
                )}
            </div>
        </Popup>
    )
}
